<div
    #filter
    class="pcg-table-filter"
    [class.d-none]="!isVisible"
>
    <div
        #filterBody
        class="pcg-table-filter-body ml-1 mt-0"
        (click)="positionFilter()"
    >
        <ng-content></ng-content>
    </div>
    <div class="pcg-table-filter-overlay"></div>
</div>
